
import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, CommonGlobalService, UUID, CallbackErrorAxios, CallbackWarningAxios } from '@umanforge/common';
import { ActionFull, ModifyAction, PostAction } from 'interfaces/action.interface';
import { API } from 'constants/api.contants';

export class ActionService {

  static getActionsFullByTaskId(
    taskId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<ActionFull[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.ACTION_FULL_BY_TASK}/${taskId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<ActionFull[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data.map( setting => { return { ...setting }; } ) );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static validateActionsById(
    taskId: string,
    actionid: string | undefined,
    userId: string,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ) {
    return new Promise( async resolve => {
      AXIOS.put( `${API.ACTION_VALIDATE}/${taskId}`, { actionId: actionid, userId: userId }, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static validateActionsByTaskId(
    actionId: string,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ) {
    return new Promise( async resolve => {
      AXIOS.put( `${API.ACTION_VALIDATE_BY_TASK}/${actionId}`, {}, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }


  static putActionsById(
    actionId: string,
    action: ModifyAction,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ) {
    return new Promise( async resolve => {
      AXIOS.put( `${API.ACTION}/${actionId}`, action, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static postAction(
    action: PostAction,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<{ id: string | null}> {
    return new Promise( async resolve => {
      AXIOS.post( `${API.ACTION}/`, action, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }
};